import { Features } from '../../types/state';
import * as actionTypes from '../../constants/actions';

export const setFeatures = (features: Features) => ({
  type: actionTypes.SPACE_SET_FEATURES,
  features,
});
